'use client'; // Required for client-side interactivity in Next.js App Router

import React, { useState, FormEvent, ChangeEvent, useEffect } from 'react';

// Define the shape of the form data
interface FormData {
    name: string;
    email: string;
    message: string;
}

export default function ContactForm() {
    const [formData, setFormData] = useState<FormData>({
        name: '',
        email: '',
        message: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [messageStatus, setMessageStatus] = useState<string | null>(null);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessageStatus(null);

        // In a real application, you would send this data to a backend API endpoint, 
        // e.g., using fetch() or a library like Axios.
        console.log('Form data submitted:', formData);

        try {
            // Example API call (replace with your actual API endpoint)
            // await fetch('/api/contact', {
            //   method: 'POST',
            //   headers: {
            //     'Content-Type': 'application/json',
            //   },
            //   body: JSON.stringify(formData),
            // });

            setMessageStatus('Message sent successfully!');
            setFormData({ name: '', email: '', message: '' }); // Reset form
        } catch (error) {
            setMessageStatus('Failed to send message. Please try again later.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div >
          
          <section  style={{ padding: "72px 24px" }}>
              <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: "48px" }}>
                  <p style={{ fontSize: "12px", fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--accent)", margin: "0 0 10px" }}>GET IN TOUCH</p>
                  <h2 style={{ fontSize: "clamp(28px, 4vw, 44px)", margin: "0 0 14px", fontWeight: 400 }}>Let's chat about your needs</h2>
                  <p style={{ color: "var(--muted)", fontSize: "16px", margin: 0 }}>Our team will get back to you within 24 hours.</p>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); alert("Thank you! We'll be in touch soon."); }} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Name */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <label style={{ textAlign: 'left', fontSize: "14px", fontWeight: 500, color: "var(--text)" }}>Full Name</label>
                    <input type="text" required placeholder="Jane Doe" style={{ background: "var(--surface)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "10px", padding: "12px 14px", color: "var(--text)", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", transition: "border-color 0.2s", outline: "none" }} 
        />
                  </div>

                  {/* Email */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <label style={{ textAlign: 'left', fontSize: "14px", fontWeight: 500, color: "var(--text)" }}>Email Address</label>
                    <input type="email" required placeholder="jane@example.com" style={{ background: "var(--surface)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "10px", padding: "12px 14px", color: "var(--text)", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", transition: "border-color 0.2s", outline: "none" }} />
                  </div>

                  {/* Company */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <label style={{ textAlign: 'left', fontSize: "14px", fontWeight: 500, color: "var(--text)" }}>Company</label>
                    <input type="text" placeholder="Acme Inc." style={{ background: "var(--surface)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "10px", padding: "12px 14px", color: "var(--text)", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", transition: "border-color 0.2s", outline: "none" }}  />
                  </div>

                  {/* Message */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <label style={{ textAlign: 'left', fontSize: "14px", fontWeight: 500, color: "var(--text)" }}>Message</label>
                    <textarea required placeholder="Tell us about your project..." style={{ background: "var(--surface)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "10px", padding: "12px 14px", color: "var(--text)", fontSize: "14px", fontFamily: "'DM Sans', sans-serif", minHeight: "120px", resize: "vertical", transition: "border-color 0.2s", outline: "none" }} />
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="btn-primary" style={{ width: "100%", padding: "14px 24px", fontSize: "16px", marginTop: "12px", height: "48px" }}>
                    Send Message
                  </button>
                </form>

                <p style={{ textAlign: "center", fontSize: "13px", color: "var(--muted)", margin: "24px 0 0", lineHeight: 1.6 }}>
                  We respect your privacy. No spam, ever. <a href="#" style={{ color: "var(--accent)", textDecoration: "none" }}>View our privacy policy</a>.
                </p>
              </div>
        </section>
      </div>    
    );
}